import { useState, useEffect } from 'react';
import { Button, Flex, Select } from '../../2022-component-library';
import { useTestContext } from '../../context/testContext';
import { fetchPracticeTests } from '../../helpers/practiceTests';
import { useAppointment } from '../../context/appointmentContext';
import { ResponsiveLoadingPage } from '.';

const ResponsiveTestSelection = ({ setStep, setActiveTab }) => {
  const { updateTestData } = useTestContext();
  const { appointment } = useAppointment() || {};
  const appointmentId = appointment?.currentAppointment?.id;
  const [selectedTest, setSelectedTest] = useState({});
  const [selectedTestCategory, setSelectedTestCategory] = useState('');
  const [testsByCategory, setTestsByCategory] = useState(null);
  const [testCategories, setTestCategories] = useState(null);

  const activateTest = () => {
    updateTestData({ eyeTestId: selectedTest.test_id, testKey: selectedTest.key });
    setStep(selectedTest.key);
  };

  const activateTestCategory = (testCategory) => {
    setSelectedTestCategory(testCategory);
    switch (testCategory) {
      case 'visualAcuity':
        setSelectedTest(testsByCategory[testCategory].find((test) => test.key === 'crowdedLogmar'));
        break;
      case 'Refraction':
        setSelectedTest(testsByCategory[testCategory].find((test) => test.key === 'RefractionTwo'));
        break;
      default:
        break;
    }
  };

  const handleTestSelection = (selectedTestKey) => {
    const testFromArray = testsByCategory[selectedTestCategory].find((test) => test.key === selectedTestKey);
    setSelectedTest(testFromArray);
  };

  useEffect(() => {
    const getCategorisedTests = async () => {
      // The appointment practice's tests, whichever account opened the session.
      const enabled = await fetchPracticeTests(appointmentId);
      if (enabled) {
        let categorised_tests = {};
        let categories = [];

        for (let category of Object.values(enabled)) {
          categories.push({
            key: category.key,
            description: category.description,
          });

          categorised_tests[category.key] = [];

          for (let categorisedTest of category.tests) {
            categorised_tests[category.key].push({
              title: categorisedTest.title,
              key: categorisedTest.key,
              id: categorisedTest.test_id,
            });
          }
        }

        setTestsByCategory(categorised_tests);
        setTestCategories(categories);
      }
    };

    if (testCategories === null) {
      getCategorisedTests();
    }
  }, [testCategories, appointmentId]);

  useEffect(() => {
    if (testsByCategory) {
      setSelectedTestCategory('visualAcuity');
      if (testsByCategory?.visualAcuity) {
        setSelectedTest(testsByCategory.visualAcuity.find((test) => test.key === 'crowdedLogmar'));
      }
    }
  }, [testsByCategory]);

  return (
    <Flex column centered height='100%'>
      {!Object.keys(selectedTest)?.length || selectedTestCategory === '' ? (
        <ResponsiveLoadingPage />
      ) : (
        <>
          <Select
            label='Select Test Category'
            width='35vw'
            marginBottom='1rem'
            value={selectedTestCategory}
            onChange={(e) => activateTestCategory(e.target.value)}
          >
            {testCategories?.map((category) => {
              return (
                <option key={`test-option-${category.key}`} value={category.key}>
                  {category.description}
                </option>
              );
            })}
          </Select>
          <Select
            label='Select Test'
            width='35vw'
            marginBottom='3rem'
            value={selectedTest.key}
            onChange={(e) => handleTestSelection(e.target.value)}
            disabled={selectedTestCategory === 'visualField'}
          >
            {selectedTestCategory &&
              testsByCategory[selectedTestCategory].map((test) => {
                return (
                  <option key={`test-option-${test.key}`} value={test.key}>
                    {test.title}
                  </option>
                );
              })}
          </Select>

          <Flex>
            <Button variant='outlined' marginRight='1rem' onClick={() => setActiveTab('set-distance')}>
              Back
            </Button>
            <Button
              disabled={selectedTestCategory === 'visualField'}
              onClick={() => {
                activateTest();
              }}
            >
              Next
            </Button>
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default ResponsiveTestSelection;
